import DateFormat from './DateFormat';

export default class DateService {

	/**
	 * @param {Date} date
	 * @return {Date}
	 */
	static getDateInUtc(date) {
		return new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
	}

	/**
	 * @param {Date} date
	 * @param {boolean} includeTime
	 * @return {string}
	 */
	static getHumanizedDate(date, includeTime = false) {
		if (!includeTime) {
			return DateFormat.format(date, 'dd.mm.yyyy');
		}

		return DateFormat.format(date, 'dd.mm.yyyy hh:ii:ss');
	}

	/**
	 * @param {Date} date
	 *
	 * @return {string}
	 */
	static getLogDate(date) {
		return DateFormat.format(date, 'yyyy-mm-dd hh:ii:ss');
	}

	/**
	 * @param {Date} date
	 * @return {string}
	 */
	static timeSince(date) {
		let seconds = Math.floor((new Date() - date) / 1000);
		let interval = Math.floor(seconds / 31536000);

		if (interval === 1) {
			return interval + ' year';
		}
		if (interval > 1) {
			return interval + ' years';
		}
		interval = Math.floor(seconds / 2592000);
		if (interval === 1) {
			return interval + ' month';
		}
		if (interval > 1) {
			return interval + ' months';
		}
		interval = Math.floor(seconds / 86400);
		if (interval === 1) {
			return interval + ' day';
		}
		if (interval > 1) {
			return interval + ' days';
		}
		interval = Math.floor(seconds / 3600);
		if (interval === 1) {
			return interval + ' hour';
		}
		if (interval > 1) {
			return interval + ' hours';
		}
		interval = Math.floor(seconds / 60);
		if (interval === 1) {
			return interval + ' minute';
		}
		if (interval > 1) {
			return interval + ' minutes';
		}

		return Math.floor(seconds) + ' seconds';
	}

	/**
	 * Returns the seconds since midnight, 1 Jan 1970
	 *
	 * @return {number}
	 */
	static getCurrentDateInSeconds() {
		return Math.round(new Date().getTime() / 1000);
	}
}


// WEBPACK FOOTER //
// ./services/DateService.js